import loadModuleOnElement from "../utils/loadModuleOnElement";

const selector = ".js-scroll-trigger[data-toggle-class], .js-scroll-trigger[data-triggers]";
const loader = () => import("./scrollTrigger");

export default function scrollTriggerLoader(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
